import { render, staticRenderFns } from "./DisqualificationDestoryConfirm.vue?vue&type=template&id=01dc8598"
import script from "./DisqualificationDestoryConfirm.vue?vue&type=script&lang=js"
export * from "./DisqualificationDestoryConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports